/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'antd';
import { formattedAccountList } from 'components/shared/AccountDropdown';
import { formattedContactAccountList } from 'components/shared/ContactDropdown';
import useDynamicForm from 'hooks/useDynamicForm';
import { IOssixProvider } from 'interfaces/otherInterface/dynamicInput';
import { IAccountInfo } from 'interfaces/queries/account';
import TransferToMNOPage from 'pages/bank/QuickTransfer/TransferToMNO';
import { getAllUserContact } from 'queries/ossix/user/userData';
import { userAccountNumbers } from 'queries/ossix/wallet/requestWallet';
import React, { useEffect, useState } from 'react';
import { TargetType } from 'types/generalType';

interface TransferToMNOPageContainerProps {
  isDrawerOpen: any;
  handleCloseOpenDrawer: () => void;
}

const TransferToMNOPageContainer: React.FC<
  TransferToMNOPageContainerProps
> = ({ isDrawerOpen, handleCloseOpenDrawer }) => {
  const [form] = Form.useForm();
  const [step, setStep] = useState(1);
  const [accountNumber, setAccountNumber] = useState();
  const [contactAccount, setContactAccount] = useState<any>();
  const [selectedBeneficiary, setSelectedBeneficiary] =
    useState<any>();
  const [selectedProvider, setSelectedProvider] = useState<
    IOssixProvider | undefined
  >();
  const { loadUserAccountNumbers, accountNumbers } =
    userAccountNumbers();
  const [displaySelectContact, setDisplaySelectContact] =
    useState(false);
  const accountNumbersInfo: IAccountInfo[] = accountNumbers;
  const selectAccountNumber = formattedAccountList(
    accountNumbersInfo,
  );

  const onHandleDisplaySelectContact = () =>
    setDisplaySelectContact(true);

  const onHandleCloseSelectContact = () => {
    setDisplaySelectContact(false);
    setSelectedBeneficiary(undefined);
    setContactAccount({
      value: '',
      label: '',
    });
  };

  const {
    isLoadingContacts,
    userContactData,
    mutate: requestSavedContact,
  } = getAllUserContact();

  const onPrevious = () => setStep((prevStep) => prevStep - 1);

  const recipientAccountNumber = formattedContactAccountList(
    userContactData &&
      userContactData?.filter(
        (item) => item?.Category === TargetType.MNOGetaway,
      ),
  );

  const beneficiaryInfo = userContactData?.find(
    (item: any) =>
      item?.DefaultWallet?.WalletNumber === contactAccount?.value,
  );

  const {
    meta,
    fields,
    provider,
    contextHolder,
    onHandleValueChange,
    loadTransferConfirmation,
    transferConfirmationData,
    onPINValuesChange,
    loadSendFundsToGateway,
    userData,
    handleInputChange,
    filterCountry,
    loadVerifyAccount,
    onHandleVerifyAccount,
    isVerifyAccountSuccess,
    fixedInputValue,
    setFixedInputValue,
    onHandleMNOTransferConfirmation,
    onHandleMNOConfirmTransfer,
    onChangeFixedInputValue,
    onHandleSaveContact,
    formData,
    setFormData,
  } = useDynamicForm({
    jsonFields: selectedProvider?.Fields as string,
    accountNumber: accountNumber,
    provider: selectedProvider,
    nextStep: setStep,
    form: form,
    accountNumberName: selectAccountNumber?.[0]?.text,
    selectedBeneficiary: selectedBeneficiary,
  });

  useEffect(() => {
    const operationCountry = userData?.[0]?.OperationCountry;
    if (operationCountry) {
      requestSavedContact({
        CountryCode: operationCountry,
      });
    }
  }, []);

  useEffect(() => {
    if (contactAccount) {
      const beneficiary = userContactData?.find(
        (item) => item.AccountNumber === contactAccount?.value,
      );
      setSelectedBeneficiary(beneficiary?.Operator);
    }
  }, [contactAccount]);

  useEffect(() => {
    if (contactAccount?.value) {
      const beneficiary = userContactData?.find(
        (item: { AccountNumber: any }) =>
          item.AccountNumber === contactAccount?.value,
      );
      setSelectedBeneficiary({
        ...beneficiary,
        ...beneficiary?.Operator,
      });

      setFormData((prev: any) => ({
        ...prev,
        ...{
          serviceNumber: contactAccount?.value,
          phoneNumber: contactAccount?.value,
        },
      }));
    }
  }, [contactAccount?.value]);

  return (
    <>
      {contextHolder}
      <TransferToMNOPage
        form={form}
        step={step}
        onPrevious={onPrevious}
        userData={accountNumbers}
        userInfo={userData}
        accountNumber={accountNumber}
        beneficiaryInfo={beneficiaryInfo}
        loadingAccount={loadUserAccountNumbers}
        setAccountNumber={setAccountNumber}
        selectAccountNumber={selectAccountNumber}
        displaySelectContact={displaySelectContact}
        contactAccount={contactAccount}
        setContactAccount={setContactAccount}
        isLoadingContacts={isLoadingContacts}
        onHandleCloseSelectContact={onHandleCloseSelectContact}
        recipientAccountNumber={recipientAccountNumber}
        onHandleDisplaySelectContact={onHandleDisplaySelectContact}
        isDrawerOpen={isDrawerOpen}
        handleCloseOpenDrawer={handleCloseOpenDrawer}
        dynamicFormItem={{
          meta,
          contextHolder: contextHolder,
          onHandleValueChange: onHandleValueChange,
          onHandleTransferConfirmation:
            onHandleMNOTransferConfirmation,
          loadTransferConfirmation: loadTransferConfirmation,
          transferConfirmationData: transferConfirmationData,
          onPINValuesChange: onPINValuesChange,
          onHandleConfirmTransfer: onHandleMNOConfirmTransfer,
          loadSendFundsToGateway: loadSendFundsToGateway,
          selectedBeneficiary,
          selectedProvider,
          setSelectedProvider,
          fields,
          handleInputChange,
          filterCountry,
          setSelectedBeneficiary,
          loadVerifyAccount,
          onHandleVerifyAccount,
          isVerifyAccountSuccess,
          provider,
          fixedInputValue,
          setFixedInputValue,
          onChangeFixedInputValue,
          onHandleSaveContact,
          formData,
        }}
      />
    </>
  );
};

export default TransferToMNOPageContainer;
